
export const _defaultSearchState = {
  keywords: [],
  placeholder: 'Search...',
  visible: false,
}

export interface SearchState {
  selected?: string,
  keywords: string[],
  placeholder: string,
  visible: boolean,
}
